import React from "react";
import { TOTAL_ACCENT_CLASS } from "./constants";
import { formatRand } from "./helpers";

const TotalCard = ({ label, value, accent = "purple", subtext }) => (
  <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm">
    <p className="text-[11px] font-bold text-gray-500 uppercase tracking-wider">
      {label}
    </p>
    <h4 className={`text-2xl font-bold mt-1 leading-none ${TOTAL_ACCENT_CLASS[accent] || TOTAL_ACCENT_CLASS.purple}`}>
      {formatRand(value)}
    </h4>
    {subtext && (
      <p className="mt-2 text-[11px] text-gray-500">{subtext}</p>
    )}
  </div>
);

export default TotalCard;
